<template>
  <va-modal
    id="privacy-policy-modal"
    ref="privacyPolicyModal"
    :value="isOpen"
    size="large"
    :showOkay="false"
    :cancelText="$t('modals.buttons.back')"
    @cancel="onCancel"
  >
    <LoadingPlaceholder v-if="isLoading" />

    <div v-else-if="isValidUrl" class="privacy-policy-content">
      <iframe ref="privacyPolicyIframe" :src="policyUrl" frameborder="0"></iframe>
    </div>

    <div v-else class="text-center py-5">
      <span class="is-bold">URL Invalido</span>
    </div>

  </va-modal>
</template>

<script>
// import ApiService from '@/api/ApiService'
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder'
export default {
  props: {
    isConsentUrl: {
      type: Boolean,
      required: false,
      default: false
    },
    url: {
      type: String,
      required: true
    }
  },
  components: {
    LoadingPlaceholder
  },
  computed: {
    policyUrl: function () {
      if(this.isConsentUrl) {
        return this.url
      }
      if (this.url.includes('https://evollu.com/legal')) {
        return this.url
      } else {
        if (this.url.startsWith('/')) {
          return `https://evollu.com/legal${this.url}`
        } else {
          return `https://evollu.com/legal/${this.url}`
        }
      }
    }
  },
  data: function () {
    return {
      isOpen: false,
      isLoading: false,
      isValidUrl: true
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    testURL: function () {
      this.$http({ url: this.policyUrl })
        .then(response => {
          this.isValidUrl = true
        })
        .catch(errors => (
          this.isValidUrl = false
        ))
        .finally(() => {
          this.isLoading = false
        })
    },
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('cancel')
      }, 750)
    }
  }
}
</script>

<style lang="scss">
#privacy-policy-modal {
  .privacy-policy-content {
    iframe {
      width: 100%;
      height: 80vh;

      body {
        padding: 0 10%;
      }
    }
  }
}
</style>
